import React from "react";
import { Country, State } from "country-state-city";
import PublicIcon from "@mui/icons-material/Public";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";

interface CountryStateSelectProps {
  selectedCountry: string;
  selectedState: string;
  onCountryChange: (value: string) => void;
  onStateChange: (value: string) => void;
  hideWrapper?: boolean;
}

export const CountryStateSelect: React.FC<CountryStateSelectProps> = ({
  selectedCountry,
  selectedState,
  onCountryChange,
  onStateChange,
  hideWrapper = false,
}) => {
  const countries = Country.getAllCountries();
  const states = selectedCountry ? State.getStatesOfCountry(selectedCountry) : [];

  // If hideWrapper is true, render without the outer grid wrapper
  if (hideWrapper) {
    return (
      <>
        {/* COUNTRY */}
        <div className="w-full">
          <label className="text-sm font-medium text-gray-600 mb-1 block">Country</label>
          <div className="h-[40px] flex items-center border border-gray-300 rounded-md px-3 bg-white">
            <PublicIcon className="text-gray-400 mr-2" fontSize="small" />
            <select value={selectedCountry} onChange={(e) => onCountryChange(e.target.value)} className="w-full bg-transparent outline-none text-gray-700 truncate">
              <option value="" disabled>
                Select country
              </option>
              {countries.map((c) => (
                <option key={c.isoCode} value={c.isoCode}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* STATE */}
        <div className="w-full">
          <label className="text-sm font-medium text-gray-600 mb-1 block">State</label>
          <div className="h-[40px] flex items-center border border-gray-300 rounded-md px-3 bg-white">
            <PersonPinCircleIcon className="text-gray-400 mr-2" fontSize="small" />
            <select
              value={selectedState}
              onChange={(e) => onStateChange(e.target.value)}
              disabled={!selectedCountry}
              className="w-full bg-transparent outline-none text-gray-700 truncate disabled:opacity-50"
            >
              <option value="" disabled>
                Select state
              </option>
              {states.map((s) => (
                <option key={s.isoCode} value={s.isoCode}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </>
    );
  }

  // Original rendering with grid wrapper (for backward compatibility)
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
      {/* COUNTRY */}
      <div className="w-full">
        <label className="text-sm font-medium text-gray-600 mb-1 block">Country</label>
        <div className="h-[40px] flex items-center border border-gray-300 rounded-md px-3 bg-white">
          <PublicIcon className="text-gray-400 mr-2" fontSize="small" />
          <select value={selectedCountry} onChange={(e) => onCountryChange(e.target.value)} className="w-full bg-transparent outline-none text-gray-700 truncate">
            <option value="" disabled>
              Select country
            </option>
            {countries.map((c) => (
              <option key={c.isoCode} value={c.isoCode}>
                {c.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* STATE */}
      <div className="w-full">
        <label className="text-sm font-medium text-gray-600 mb-1 block">State</label>
        <div className="h-[40px] flex items-center border border-gray-300 rounded-md px-3 bg-white">
          <PersonPinCircleIcon className="text-gray-400 mr-2" fontSize="small" />
          <select
            value={selectedState}
            onChange={(e) => onStateChange(e.target.value)}
            disabled={!selectedCountry}
            className="w-full bg-transparent outline-none text-gray-700 truncate disabled:opacity-50"
          >
            <option value="" disabled>
              Select state
            </option>
            {states.map((s) => (
              <option key={s.isoCode} value={s.isoCode}>
                {s.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};